<template>
  <div>
    <el-card class="ele-card">
      <div class="control">
        <label class="label inline-block">第三方店铺</label>
        <el-select v-model="selectThirdShop" filterable clearable placeholder="请选择">
          <el-option
          v-for="item in thirdShopList"
          :key="item.shopId"
          :label="item.shopName"
          :value="item.shopId">
          </el-option>
        </el-select>
      </div>
      <div class="control">
        <label class="label inline-block">穿衣店铺</label>
        <el-select v-model="selectCyzsShop" filterable clearable placeholder="请选择">
          <el-option
          v-for="item in cyzsShopList"
          :key="item.userId"
          :label="item.name"
          :value="item.userId">
          </el-option>
        </el-select>
      </div>
      <div class="control">
        <label class="label inline-block">添加人</label>
        <el-select v-model="selectOperation" filterable clearable placeholder="请选择">
          <el-option
          v-for="item in operationUsers"
          :key="item.userId"
          :label="item.username"
          :value="item.userId">
          </el-option>
        </el-select>
      </div>
      <div class="control">
        <label class="label inline-block">状态</label>
        <el-select v-model="status" clearable placeholder="请选择">
          <el-option key="0" label="待抓取" value="0"></el-option>
          <el-option key="1" label="抓取中" value="1"></el-option>
        </el-select>
      </div>
      <div class="control">
        <label class="label inline-block">平台</label>
        <el-select v-model="platform" multiple clearable placeholder="请选择">
          <el-option key="1" label="淘宝" value="1"></el-option>
          <el-option key="2" label="天猫" value="2"></el-option>
          <el-option key="3" label="蘑菇街" value="3"></el-option>
        </el-select>
      </div>
      <el-button type="primary fright" @click="doSearch">搜索</el-button>
    </el-card>
    <el-card class="ele-card clearfix">
      <div class='button-wrap'>
        <el-button type="primary" size="small" @click="fetchConfirm">批量增量抓取</el-button>
        <el-button type="success" size="small" @click='addShopForm'>新增店铺</el-button>
      </div>
      <el-pagination
        class='fright'
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </el-card>
    <el-table v-loading="loading" :data="tableList" @selection-change="handleSelectionChange" ref="table" @cell-click='cellClick'>
      <el-table-column type="selection" :selectable="selectable" width="55" align='center'></el-table-column>
      <el-table-column prop="shopName" label="淘宝店铺" align='center'>
        <template slot-scope="scope">
          <a :href='getShopLink(scope.row.shopId)' target='_blank'>{{scope.row.shopName}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="platform" label="平台" :formatter="formatPlatform" align='center'></el-table-column>
      <el-table-column label="对应穿衣店铺" align='center'>
        <template slot-scope="scope">
          <div :class="scope.row.cyzsStatus == 0 ? 'red': ''">{{scope.row.cyzsUsername}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="adminUserName" label="添加人" align='center'></el-table-column>
      <el-table-column prop="dataUpdateTime" :formatter="formatTimestamp2date" label="增量更新时间" align='center'></el-table-column>
      <el-table-column label="首页图片" align='center'>
        <template slot-scope="scope">
          <template v-for='(item, index) in scope.row.homeImages' v-if='index < 2' >
            <popover-image :img='item'></popover-image>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="goodsCount" label="入库商品数量" align='center'></el-table-column>
      <el-table-column prop="goodRate" label="好评率>" align='center'>
        <template slot-scope="scope">
          {{scope.row.goodRate}}%
        </template>
      </el-table-column>
      <el-table-column label="自动审核" align='center' width='140'>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isAutoVerify" active-text='开启' inactive-text='关闭' @change="changeAutoVerify(scope.row.shopId, scope.row.isAutoVerify, scope.row.platform)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="抓取状态" align='center' width='140'>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-text='开启' inactive-text='关闭' @change="changeStatus(scope.row.shopId, scope.row.status, scope.row.platform)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align='center'>
        <template slot-scope="scope">
          <el-button size="mini" @click='handleEdit(scope.$index, scope.row)'>编辑</el-button>
          <el-button v-if="scope.row.isHide" size="mini" type="success" @click="handleDelete(scope.$index, scope.row)">启用</el-button>
          <el-button v-if="!scope.row.isHide" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">停用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class='fright bottom-pagination'
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount">
    </el-pagination>
    <el-dialog title="新增店铺" :visible.sync="addShopFormVisible" :lock-scroll='false'>
      <el-form :model="shopForm" :rules="shopRules" label-width="120px">
        <el-form-item label="平台">
          <el-radio v-model="shopForm.platform" :label="1">淘宝</el-radio>
          <el-radio v-model="shopForm.platform" disabled :label="2">天猫</el-radio>
          <el-radio v-model="shopForm.platform" disabled :label="3">蘑菇街</el-radio>
        </el-form-item>
        <el-form-item label="第三方店铺地址" prop="shopHomeUrl">
          <el-input v-model="shopForm.shopHomeUrl" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="对应穿衣店铺" prop='cyzsUserId'>
          <el-select v-model="shopForm.cyzsUserId" filterable placeholder="请选择">
            <el-option v-for="item in cyzsShopList" :key="item.userId" :label="item.name" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否自动审核">
          <el-radio v-model="shopForm.isAutoVerify" :label="0">手动</el-radio>
          <el-radio v-model="shopForm.isAutoVerify" :label="1">自动</el-radio>
        </el-form-item>
        <el-form-item label="过滤条件" prop='goodRate'>
          <el-input v-model="shopForm.goodRate" auto-complete="off" class='width-auto'>
            <template slot="prepend">好评率 ></template>
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addShopFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addShop">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import { formatDate } from 'UTILS/date';
import { Message } from 'element-ui';
import PopoverImage from './popoverImage'
import {formatDFSUrl} from 'UTILS/_url'
import JSZip from 'jszip'
import fileSaver from 'file-saver'

const NORMAL_STATUS = 2; // 抓取状态正常

export default {
  data() {
    return {
      shopRules: {
        shopHomeUrl: [
          { required: true, message: '请输入店铺地址', trigger: 'blur' },
        ],
        cyzsUserId: [
          { required: true, message: '请输入店铺', trigger: 'change' },
        ],
      },
      selectThirdShop: '',
      thirdShopList: [],
      selectCyzsShop: '',
      cyzsShopList: [],
      selectOperation: '',
      operationUsers: [],
      status: '',
      platform: '',
      totalCount: 0,
      page: 1,
      pageSize: 20,
      tableList: [],
      shopForm: {
        shopId: '',
        platform: 1,
        shopHomeUrl: '',
        cyzsUserId: '',
        isAutoVerify: 0,
        goodRate: '',
      },
      selectList: [],
      addShopFormVisible: false,
      loading: false
    }
  },
  components: {
    PopoverImage
  },
  mounted() {
    this.getOperationUsers();
    this.getCyzsShop();
    this.getThirdShop();
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        shopId: this.selectThirdShop,
        relatedUserId: this.selectCyzsShop,
        adminUserId: this.selectOperation,
        status: this.status,
        platform: this.platform
      }
      this.loading = true;
      HttpRequest.get('/admin.php?method=thirdpartybusinessuser.getPool', params).then((response) => {
        this.loading = false;
        this.totalCount = response.data.count;
        this.tableList = _.toArray(response.data.list).map((item) => {
          item.status = item.dataUpdateStatus == 2
          item.isAutoVerify = item.isAutoVerify == 1
          return item
        })
      })
    },
    doSearch() {
      this.page = 1
      this.getList()
    },
    fetchConfirm() {
      if (this.selectList.length == 0) {
        Message({ type: 'info', message: '请勾选商品' });
        return;
      }
      this.$confirm('请确认：当前选中商品重新抓取，已成功商品不再进行抓取，入库后每天会定时更新', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = this.selectList.map((item) => {
          return { shopId: item.shopId, platform: item.platform }
        })
        HttpRequest.post('/admin.php?method=thirdpartybusinessuser.updatePool', { shopIndexes: params }).then((response) => {
          Message({ type: 'success', message: '操作成功!' });
            this.$refs.table.clearSelection();
        }).catch(() => {
          Message({ type: 'info', message: '操作失败' });
        })
      }).catch(() => {
        Message({ type: 'info', message: '已取消操作' });
      });
    },
    addShop() {
      if (this.shopForm.shopHomeUrl && this.shopForm.cyzsUserId) {
        HttpRequest.get('/admin.php?method=thirdpartybusinessuser.doAddShop', this.shopForm).then(() => {
          Message({ type: 'success', message: '操作成功!' });
          this.getList();
        })
        this.addShopFormVisible = false;
      } else {
        Message({ type: 'info', message: '请填写必填项' });
      }
    },
    addShopForm() {
      this.addShopFormVisible = true;
      this.shopForm =  {
        shopId: '',
        platform: 1,
        shopHomeUrl: '',
        cyzsUserId: '',
        isAutoVerify: 0,
        goodRate: '',
      }
    },
    handleSizeChange(value) {
      this.pageSize = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.page = value;
      this.getList();
    },
    handleSelectionChange(value) {
      this.selectList = value;
    },
    handleEdit(index, row) {
      let params = {
        shopId: row.shopId,
        platform: row.platform
      }
      HttpRequest.get('/admin.php?method=thirdpartybusinessuser.getShop', params).then((response) => {
        let data = response.data;
        this.shopForm.shopId = row.shopId;
        this.shopForm.platform =  parseInt(data.platform);
        this.shopForm.isAutoVerify = data.isAutoVerify;
        this.shopForm.goodRate = data.goodRate;
        this.shopForm.cyzsUserId = parseInt(row.cyzsUserId);
        this.shopForm.shopHomeUrl = data.shopHomeUrl;
      })
      this.addShopFormVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm(`请确认：${row.isHide ? '启用': '停用'}当前店铺`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.isHide) {
          HttpRequest.get('/admin.php?method=thirdpartybusinessuser.setPoolHide', { shopId: row.shopId, hide: 0 }).then(() => {
            this.tableList[index].isHide = 0
            Message({ type: 'success', message: '操作成功!' });
          })
        } else {
          this.tableList.splice(index, 1)
          HttpRequest.get('/admin.php?method=thirdpartybusinessuser.removePool', { shopId: row.shopId }).then((response) => {
            Message({ type: 'success', message: '操作成功!' });
          }).catch(() => {
            Message({ type: 'info', message: '操作失败' });
          })
        }
      }).catch(() => {
        Message({ type: 'info', message: '已取消操作' });
      });
    },
    //改变自动审核状态
    changeAutoVerify(shopId, isAutoVerify, platform) {
      let params = {
        shopId,
        isAutoVerify: isAutoVerify ? 1 : 0,
        platform
      }
      HttpRequest.get('/admin.php?method=thirdpartybusinessuser.doSaveAutoVerify', params)
    },
    //改变抓取状态
    changeStatus(shopId, dataUpdateStatus, platform) {
      let params = {
        shopId,
        dataUpdateStatus: dataUpdateStatus ? 2 : 1,
        platform
      }
      HttpRequest.get('/admin.php?method=thirdpartybusinessuser.doSaveDataUpdateStatus', params)
    },
    //图片点击下载
    cellClick(row, column) {
      if (column.label == '首页图片') {
        this.downloadImage(row.homeImages)
      }
    },
    //判断当前列是否可选
    selectable(row, index) {
      return row.dataUpdateStatus == NORMAL_STATUS
    },
    //打包下载首页图片
    downloadImage(images) {
      const promises = _.toArray(images).map((item) => {
        return this.toDataURL(item)
      })
      Promise.all(promises).then((response) => {
        var zip = new JSZip();
        let img = zip.folder("images");
        _.each(response,(item,index) => {
          img.file(`${index}.jpg`, item, {base64: true});
        })
        zip.generateAsync({type:"blob"}).then((content) => {
          fileSaver.saveAs(content, "image.zip");
        });
      })
    },
    getOperationUsers() {
      HttpRequest.get('/admin.php?method=shoppingguide.getOperationUsers').then((response) => {
        this.operationUsers = _.toArray(response.data)
      })
    },
    getCyzsShop() {
      HttpRequest.get('/admin.php?method=thirdpartybusinessuser.getSimpleList').then((response) => {
        this.cyzsShopList = _.toArray(response.data)
      })
    },
    getThirdShop() {
      HttpRequest.get('/admin.php?method=thirdpartybusinessuser.getShopList').then((response) => {
        this.thirdShopList = _.toArray(response.data.list)
      })
    },
    formatTimestamp2date(row, column, cellValue, index) {
      return formatDate(cellValue, "yyyy-MM-dd hh:mm:ss");
    },
    formatPlatform(row, column, cellValue, index) {
      return cellValue == 1 ? '淘宝' : cellValue == 2 ? '天猫' : '蘑菇街';
    },
    getShopLink(shopId) {
      return `https://shop${shopId}.taobao.com`
    },
    //图片链接转base64
    toDataURL(img) {
      return fetch(formatDFSUrl(img.image)).then(response => response.blob())
      .then(blob => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result.replace(/^data:image\/(png|jpg|jpeg);base64,/, ""))
        reader.onerror = reject
        reader.readAsDataURL(blob)
      }))
    },
  }
}
</script>
<style lang="less" scoped>
.el-button+.el-button {
  margin-left: 0;
  margin-top: 10px;
}
.width-auto {
  width: auto;
}
.ele-card {
    margin-bottom: 10px;
}
.button-wrap {
  display: inline-block;
}
.center {
  text-align: center;
}
.red {
  color: red;
}
.bottom-pagination {
  margin: 20px 0;
}
</style>
